module.exports = __webpack_public_path__ + "img/24110801.a6c2f1cd.png";